import { triggerAsyncId } from 'async_hooks';
import React from 'react';
import { CoachIcon } from '../svg/CoachIcon';
import { GamerIcon } from '../svg/GamerIcon';
import { CoachDollar } from '../svg/scholarships/CoachDollar';
import { CoachScholar } from '../svg/scholarships/CoachScholar';
import { Controller } from '../svg/scholarships/Controller';
import { DollarCard } from './card/DollarCard';
import { OpporCard } from './card/OpporCard';

type Props = {
    className?: string;
};

export const DollarCurrent: React.FC<Props> = ({ className }) => {
    return (
        <div className="scholar-dollar-current">
            <div className="container slim">
                <div className="content">
                    <h2 className="tagline">{'Previous Esports Scholarship Opportunities'}</h2>
                    <p className="description"></p>
                    <div className="dollar-grid">
                        <DollarCard
                            dark={true}
                            description={
                                'With eNASCAR, we hosted a Rocket League series & Coding Challenge to award $7,000 in Scholar Dollars'
                            }
                            tagline={'ENASCAR'}
                            buttonText={'more info'}
                            buttonLink={'https://staypluggedin.com'}
                            imageSrc={'/images/sponsor-logos/enascar-logo.png'}
                            width={265}
                            height={57}
                            needsPadd={false}
                        />
                        <DollarCard
                            dark={true}
                            description={
                                'A valued partner, we host continuous Scholar Dollar Essay Contests with UFEA.'
                            }
                            tagline={'UFEA'}
                            buttonText={'more info'}
                            buttonLink={'https://ufea.gg'}
                            imageSrc={'/images/sponsor-logos/ufea-horiz-light.png'}
                            width={180}
                            height={72}
                            needsPadd={false}
                        />
                        <DollarCard
                            dark={true}
                            description={'In partnership with PAX Arena, we hosted a $10K Showcase in Seattle, WA.'}
                            tagline={'PAX WEST'}
                            buttonText={'more info'}
                            buttonLink={'https://helix-showcase.staypluggedin.gg/pax-showcase'}
                            imageSrc={'/images/sponsor-logos/pax-west-white.png'}
                            width={110}
                            height={65}
                            needsPadd={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
